export { default } from './SchoolIntro'
